import redaxios, { type Options } from 'redaxios';

const redaxiosInstance = redaxios.create();

export const request = async <ResponseData = unknown>(configOptions: Options): Promise<ResponseData> => {
	const token = localStorage.getItem('auth_token');

	const headers = {
		...configOptions.headers,
		'Content-Type': 'application/json',
		'Cache-Control': 'no-cache',
		Accept: 'application/json',
		...(token ? { Authorization: `Bearer ${token}` } : {})
	};

	const response = await redaxiosInstance<ResponseData>({
		...configOptions,
		headers: headers,
		withCredentials: true
	});

	return response.data;
};
